import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { RfrCplSearchI } from 'src/app/api/rfr-cpl-search/rfr-cpl-search.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import * as actions from './rfr-cpl-search.actions';

@Injectable()
export class RfrCplSearchEffects {
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);

  load$ = createEffect(() => this.actions$.pipe(
    ofType(actions.load),
    mergeMap(({ query }) => this.sharedGenericService.invoke(ApiRfrMethod.rfrCplSearch, query).pipe(
      map((data: RfrCplSearchI) => actions.received({ data: data.result })),
      catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })]),
    )),
  ));
}
